import { render } from "./App.vue?vue&type=template&id=62fff4d6"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=62fff4d6&lang=less"

import exportComponent from "E:\\工作\\Owner项目\\在线考试系统\\web端\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__